import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Public from './components/Public'
import Login from './features/auth/Login';
import Register from './features/auth/Register';
import ForgotPassword from './features/auth/ForgotPassword';
import ResetPassword from './features/auth/ResetPassword';
import EmailConfirmed from './features/auth/EmailConfirmed';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import DashLayout from './components/DashLayout'
import Welcome from './features/auth/Welcome'
import UsersList from './features/users/UsersList'
import EditUser from './features/users/EditUser'
import NewUserForm from './features/users/NewUserForm'
import Prefetch from './features/auth/Prefetch'
import PersistLogin from './features/auth/PersistLogin'
import RequireAuth from './features/auth/RequireAuth'
import { ROLES } from './config/roles'
import useTitle from './hooks/useTitle';
import { useTranslation } from 'react-i18next';

// New accounts default to roles: ["Free"] (backend models/User.js), and "Free" is not in
// ROLES — so RequireAuth bounces them straight back to /login, which looks like a failed
// login. In development, grant Free the same dashboard access as Employee. Production is
// left untouched until the Free tier's permissions are defined. Note this widens only the
// dashboard guard: the Manager/Admin routes below are deliberately not included, so Free
// gets exactly Employee-level access and no user management.
// CRA inlines process.env.NODE_ENV at build time ('development' for npm start).
const DASH_ROLES = [
  ...Object.values(ROLES),
  ...(process.env.NODE_ENV === 'development' ? ['Free'] : [])
]

function App() {
  const { t } = useTranslation()
  useTitle(t('titles.app'))

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {/* public routes */}
        <Route index element={<Public />} />
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Register />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="emailConfirmed" element={<EmailConfirmed />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="terms" element={<Terms />} />

        {/* Protected Routes */}
        <Route element={<PersistLogin />}>
          <Route element={<RequireAuth allowedRoles={DASH_ROLES} />}>
            <Route element={<Prefetch />}>
              <Route path="dash" element={<DashLayout />}>

                <Route index element={<Welcome />} />
                <Route path="spread/:spreadId" element={<Welcome />} />

                <Route element={<RequireAuth allowedRoles={[ROLES.Manager, ROLES.Admin]} />}>
                  <Route path="users">
                    <Route index element={<UsersList />} />
                    <Route path=":id" element={<EditUser />} />
                    <Route path="new" element={<NewUserForm />} />
                  </Route>
                </Route>

              </Route>{/* End Dash */}
            </Route>
          </Route>
        </Route>{/* End Protected Routes */}

      </Route>
    </Routes >
  );
}

export default App;
